export default "__VITE_ASSET__6DHqjTtf__"